import { Route, Routes } from "react-router-dom";
import { Layout } from "./Layout";
import { Home } from "./pages/Home";
import { Solutions } from "./pages/Solutions";
import { Platform } from "./pages/Platform";
import { Company } from "./pages/Company";
import { Contact } from "./pages/Contact";
import { Careers } from "./pages/Careers";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";
import { GovernmentDataRequestPolicy } from "./pages/GovernmentDataRequestPolicy";

export function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/company" element={<Company />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/government-data-request-policy" element={<GovernmentDataRequestPolicy />} />
        {/* Unknown paths fall back to the home page. */}
        <Route path="*" element={<Home />} />
      </Route>
    </Routes>
  );
}
